<div id="partnerschaftsAngaben">

    <div class="mb-5x pt-1">
        <div class="d-flex justify-content-between mb-3x">
            <h2>{{ 'COMMON_UI.FRAGEBOGEN.PARTNERSCHAFT.PERSONENSTAND_TITEL' | translate }}</h2>
            <common-ui-daten-uebernahme
                    (picked)="onPartnerschaftPicked()"
                    [itemTemplate]="datenuebernahmePartnerschaft"
                    [items]="stammdaten?.partnerschaft?.partner?.ehepartner" [readonly]="readonly"
                    context="Partnerschaft">
            </common-ui-daten-uebernahme>
        </div>
        <common-ui-personenstand
                [(data)]="data.personenstand" [readonly]="readonly">
        </common-ui-personenstand>
    </div>

    <div *ngIf="canToggleEhepartnerAngaben" class="form-row mb-3x">
        <div class="col-12 d-flex common-ui-switch-parent">
            <common-ui-switch
                    [(checked)]="showEhepartnerAngaben"
                    [readonly]="readonly" id="switchEhepartnerAngaben">
            </common-ui-switch>
            <h5>{{ 'COMMON_UI.FRAGEBOGEN.PARTNERSCHAFT.EHEPARNTER_ANGABEN_TOGGLE' | translate }}</h5>
        </div>
    </div>

    <div *ngIf="showEhepartnerAngaben">
        <div class="mb-5x">
            <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.PARTNERSCHAFT.EHEGATTE_TITEL' | translate }}</h2>
            <common-ui-person
                    [(data)]="data.ehepartner" [readonly]="readonly">
            </common-ui-person>
            <common-ui-steueridentifikation [showWirtschaftsIdNummer]="false"
                    [(data)]="data.ehepartnerSteueridentifikation" [readonly]="readonly">
            </common-ui-steueridentifikation>
        </div>

        <div>
            <div class="form-row mb-3x">
                <div class="col-12 d-flex common-ui-switch-parent">
                    <common-ui-switch
                            id="switchEhepartnerAdressAngaben"
                            [(checked)]="showEhepartnerAdressAngaben"
                            (checkedChange)="clearAddresses($event)"
                            [readonly]="readonly">
                    </common-ui-switch>
                    <h5>{{ 'COMMON_UI.FRAGEBOGEN.PARTNERSCHAFT.EHEPARNTER_ADRESSE_TOGGLE' | translate }}</h5>
                </div>
            </div>

            <div *ngIf="showEhepartnerAdressAngaben" class="mb-5x">
                <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.PARTNERSCHAFT.EHEGATTE_ADRESSE_TITEL' | translate }}</h2>
                <common-ui-adresserfassung
                        [(auslandsadresse)]="data.ehepartnerAuslandsadresse"
                        [(inlandsadresse)]="data.ehepartnerInlandsadresse"
                        [readonly]="readonly"
                        [stammdatenAuslandsAdresse]="stammdaten?.partnerschaft?.ehepartnerAuslandsadressen?.array"
                        [stammdatenInlandsadresse]="stammdaten?.partnerschaft?.ehepartnerInlandsadressen?.array"
                        disablePostfachadresse="true">
                </common-ui-adresserfassung>
            </div>
        </div>
    </div>

</div>

<ng-template #datenuebernahmePartnerschaft let-item="item">
    <h4 class="list-group-item-heading">
        {{item?.titel}} {{item?.vorname}} {{item?.namensvorsatz}} {{item?.namenszusatz}} {{item?.nachname}}
        <span *ngIf="item?.geburtsname">geb. {{item?.geburtsname}}</span>
    </h4>
</ng-template>
